import { jsx, jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { useClassNamePrefix } from "../../../auxiliary/useClassNamePrefix.js";
import { toStateClass } from "../../../utils/toStateClass.js";
const FilePreview = memo(({ actions, children, isActive, overlay }) => {
  const prefix = useClassNamePrefix();
  return /* @__PURE__ */ jsx("div", { className: classNames(`${prefix}filePreview`, toStateClass("active", isActive)), children: /* @__PURE__ */ jsxs("div", { className: `${prefix}filePreview-in`, children: [
    overlay && /* @__PURE__ */ jsx("div", { className: `${prefix}filePreview-overlay`, children: overlay }),
    /* @__PURE__ */ jsx("div", { className: `${prefix}filePreview-preview`, children })
  ] }) });
});
FilePreview.displayName = "FilePreview";
export {
  FilePreview
};
//# sourceMappingURL=FilePreview.js.map
